import { isPS, isRS } from '@/utils';

export const INITIAL_PAGE = '1';

export const DISPLAY_SETTING_BODY_HEIGHT = 464;
export const PREVIEW_ROW_ID = 'preview-row';

export const MAXIMUM_SEARCH_HISTORY_LIMIT = 30;

export const PROJECT_BASE_DIR = isRS() && !isPS() ? '/rs/project' : '/project';

export const PS_MAX_CASCADER_SELECTION = 5;

export const PS_MAX_KEYWORD_SEARCH_LENGTH = 30;

export const MAX_PAYMENTS_WITH_COMMA = 9 + 2;
